import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { AGENT_API_PATH } from "@/modules/Agent/constants";
import { formatString } from "@/core/utils/helpers";
import { AgentPermissionsChangeVerificationRequestModel } from "@/modules/Agent/models/agentPermissionsChangeVerification.request";
import {
  AgentPricingResponse,
  AgentPricingUpdatePayload,
} from "@/core/interfaces/state/agentState.interface";
class AgentService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public updateAgentPermissions(
    organizationId: string,
    agentId: string,
    permissions: { [key: string]: boolean },
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(
        AGENT_API_PATH.UPDATE_AGENT_PERMISSIONS,
        organizationId,
        agentId,
      ),
      permissions,
    );
  }

  public agentPermissionsChangeVerification(
    body: AgentPermissionsChangeVerificationRequestModel,
  ) {
    return this.restClient.post(
      AGENT_API_PATH.PERMISSIONS_CHANGE_VERIFICATION,
      body,
    );
  }

  public deleteAgent(id: string): Promise<ICoreResponse> {
    return this.restClient.delete(AGENT_API_PATH.DELETE_AGENT, id + "/");
  }

  public getAgentPricing(
    agentId: string,
  ): Promise<ICoreResponse<ICoreResponse<AgentPricingResponse>>> {
    return this.restClient.get(AGENT_API_PATH.GET_AGENT_PRICING(agentId));
  }

  public updateAgentPricing(
    agentId: string,
    payload: AgentPricingUpdatePayload,
  ): Promise<ICoreResponse<ICoreResponse<AgentPricingResponse>>> {
    return this.restClient.put(
      AGENT_API_PATH.UPDATE_AGENT_PRICING(agentId),
      payload,
    );
  }
}

export default AgentService;
